import {
  deleteTrackingImage,
  postAddTrackingImage,
} from "helpers/services/trackingImage"
import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import {
  addTrackingImageError,
  addTrackingImageSuccess,
  deleteTrackingImageError,
  deleteTrackingImageSuccess,
} from "store/actions"
import { ADD_TRACKING_IMAGE, DELETE_TRACKING_IMAGE } from "./actionTypes"

function* addTrackingImageOnSaga({ payload: { trackingImageForm } }) {
  try {
    const response = yield call(postAddTrackingImage, trackingImageForm)
    if (response.success) {
      yield put(addTrackingImageSuccess(response.message))
    } else {
      yield put(addTrackingImageError(response.message))
    }
  } catch (error) {
    yield put(addTrackingImageError(error.message))
  }
}

function* deleteTrackingImageOnSaga({ payload: { image } }) {
  try {
    const response = yield call(deleteTrackingImage, image)
    if (response.success) {
      yield put(deleteTrackingImageSuccess(response.message))
    } else {
      yield put(deleteTrackingImageError(response.message))
    }
  } catch (error) {
    yield put(deleteTrackingImageError(error.message))
  }
}

function* TrackingImageSaga() {
  yield takeEvery(ADD_TRACKING_IMAGE, addTrackingImageOnSaga)
  yield takeEvery(DELETE_TRACKING_IMAGE, deleteTrackingImageOnSaga)
}

export default TrackingImageSaga
